import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'zwi-call-to-action',
    templateUrl: './call-to-action.component.html',
    styleUrls: ['./call-to-action.component.scss'],
    standalone: false
})
export class CallToActionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
